import {useNavigate} from "react-router-dom";

export const Already: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="text-sm text-center pb-12">
      Уже есть аккаунт?{" "}
      <span className="text-primary" onClick={() => navigate("/auth/sign-in")}>
        Войти
      </span>
    </div>
  );
};
